import { MODAL_IMAGE_HEIGHT } from "../constants/variables";

export const useModalHeightImage = (arrayLength: number) => {
  return arrayLength <= 2
    ? MODAL_IMAGE_HEIGHT
    : arrayLength <= 4
    ? MODAL_IMAGE_HEIGHT * 2
    : MODAL_IMAGE_HEIGHT * 3;
};
